import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { ModalService } from 'src/app/core/services/modal/modal.service';


@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  @Input() public accion: any;
  @Input() public title: any;
  @Input() public link: any;
  @Input() idModal: string;
  @Input() textDescription: string;
  @Output() confirmation : EventEmitter<Boolean> = new EventEmitter();
  constructor(private _MODAL: ModalService) { }

  ngOnInit() {

  }

  close() {
    this._MODAL.closeModal(this.idModal);
  }
  confirmationAndclose(){
    this.close();
    this.confirmation.emit(true);
  }

  cancelAndclose(){
    this.close();
    this.confirmation.emit(false);
  }


}
